import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Input,
} from '@nextui-org/react';
import { debounce } from 'lodash';
import React, { useState } from 'react';

import { HeaderSearchIcon, IconArrowDown, SortMobileIcon } from '@/assets';
import useGetWidth from '@/hooks/useGetWidth';

export enum SORT {
  desc = 'DESC',
  asc = 'ASC',
}

const LIST_SORT = [
  {
    key: SORT.desc,
    title: 'Date created (newest)',
  },
  {
    key: SORT.asc,
    title: 'Date created (oldest)',
  },
];

const ListBarCollectionDetail: React.FC<{
  onChangeSearch: (value: string) => void;
  onChangeSort: (value: SORT) => void;
}> = ({ onChangeSearch, onChangeSort }) => {
  const [sort, setSort] = useState<SORT>(SORT.desc);
  const screenWidth = useGetWidth();

  return (
    <div className="flex w-full flex-wrap items-center">
      <div className="ml-2 rounded-[100px] bg-gray-50 sm:ml-0 sm:w-[calc(100%-48px)]">
        <Input
          classNames={{
            input: ['dark:placeholder:text-white font-normal text-14 pl-1', 'rounded-[100px]'],
            innerWrapper: 'bg-transparent rounded-[100px]',
            inputWrapper:
              'bg-transparent rounded-[100px] shadow-none h-[45px] sm:h-[40px] min-w-[450px] lg:min-w-[260px] sm:w-[100%] sm:min-w-0',
          }}
          onChange={debounce((e) => onChangeSearch(e.target.value), 500)}
          startContent={<HeaderSearchIcon />}
          placeholder="Search in collection"
        />
      </div>
      <div className="ml-2 sm:w-[40px]">
        <Dropdown>
          <DropdownTrigger>
            {screenWidth > 575 ? (
              <div className="flex w-[210px] cursor-pointer items-center justify-between rounded-[100px] bg-[#f8f9fd] px-[16px] py-[12px] text-[14px] text-black sm:w-full">
                {LIST_SORT.find((item) => item.key === sort)?.title}{' '}
                <IconArrowDown className="-mt-1 ml-1" />
              </div>
            ) : (
              <Button className="m-0 hidden h-fit min-w-0 rounded-full bg-gray-50 p-2 md:block">
                <SortMobileIcon />
              </Button>
            )}
          </DropdownTrigger>
          <DropdownMenu
            aria-label="Static Actions"
            onAction={(e: any) => {
              setSort(e);
              onChangeSort(e);
            }}
          >
            {LIST_SORT.map((item) => (
              <DropdownItem key={item.key}>{item.title}</DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
};

export default ListBarCollectionDetail;
